import React, { FC, SVGProps } from 'react';

export const HamburgerIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15.5714 2.28516C15.7857 2.28516 16 2.10658 16 1.85658V0.713728C16 0.499442 15.7857 0.285156 15.5714 0.285156H0.428571C0.178571 0.285156 0 0.499442 0 0.713728V1.85658C0 2.10658 0.178571 2.28516 0.428571 2.28516H15.5714ZM15.5714 7.99944C15.7857 7.99944 16 7.82087 16 7.57087V6.42801C16 6.21373 15.7857 5.99944 15.5714 5.99944H0.428571C0.178571 5.99944 0 6.21373 0 6.42801V7.57087C0 7.82087 0.178571 7.99944 0.428571 7.99944H15.5714ZM15.5714 13.7137C15.7857 13.7137 16 13.5352 16 13.2852V12.1423C16 11.928 15.7857 11.7137 15.5714 11.7137H0.428571C0.178571 11.7137 0 11.928 0 12.1423V13.2852C0 13.5352 0.178571 13.7137 0.428571 13.7137H15.5714Z"
        fill="#565757"
      />
    </svg>
  );
};
